import React from 'react';
import { useTranslation } from 'react-i18next';
import { MeetingProgress } from '../../../services/api.service';
import { useThrottledValue } from '../../../hooks/use-throttled-value.hook';
import { formatEtaLabel } from '../utils/processing-format';
import styles from './row-progress.module.scss';

/** Задача L1: ETA в строке списка обновляется не чаще раза в 10с — иначе минуты
 *  мелькают на каждый тик общего поллинга списка (4с). */
const ETA_LABEL_THROTTLE_MS = 10000;

interface RowProgressProps {
  progress?: MeetingProgress;
}

/** Компактный индикатор живого прогресса в карточке списка: тонкий прогресс-бар +
 *  "% · текущий этап · ~ETA". Рендерится вместо waveform, пока встреча обрабатывается. */
const RowProgress: React.FC<RowProgressProps> = ({ progress }) => {
  const { t } = useTranslation();
  const percent = Math.max(0, Math.min(100, progress?.progress ?? 0));
  const activeStage = progress?.stages?.find(s => s.state === 'active');
  const stageTitle = activeStage?.title || progress?.message;
  const etaLabel = useThrottledValue(formatEtaLabel(progress?.eta_sec, t), ETA_LABEL_THROTTLE_MS);

  return (
    <div className={styles.rowProgress}>
      <div className={styles.track} role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100}>
        <div className={styles.fill} style={{ width: `${percent}%` }} />
      </div>
      <span className={styles.label}>
        {percent}%
        {stageTitle && <> · {stageTitle}</>}
        {' · '}
        {t('processing.remaining')}: {etaLabel}
      </span>
    </div>
  );
};

export default RowProgress;
